import { render, staticRenderFns } from "./rightXm.vue?vue&type=template&id=5d77f352&scoped=true&"
import script from "./rightXm.vue?vue&type=script&lang=js&"
export * from "./rightXm.vue?vue&type=script&lang=js&"
import style0 from "./rightXm.vue?vue&type=style&index=0&id=5d77f352&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77f352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d77f352')) {
      api.createRecord('5d77f352', component.options)
    } else {
      api.reload('5d77f352', component.options)
    }
    module.hot.accept("./rightXm.vue?vue&type=template&id=5d77f352&scoped=true&", function () {
      api.rerender('5d77f352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zzy/drawer/rightBar/rightXm.vue"
export default component.exports